import { WriteHook, useMutationManager } from 'react-query-state-manager'

import { submitRFIApplication } from 'commons/service/client/application'
import { PortalName } from 'commons/types/enums'

export const useSubmitRFIForm: WriteHook<{ id: number; p: PortalName }, unknown> = (opts) =>
  useMutationManager<{ id: number; p: PortalName }, unknown>(submitRFIApplication, opts)
